import cookie from 'cookie-utils-js';
import dayjs from 'dayjs';
import { mapGetters } from 'vuex';
import { getNotifyList, updateReadNotifyStatus } from '@/api/notify';
import { loadingIcon } from '@/svg';
import { mixins } from '@/mixins';

export default {
  components: {},
  
  name: 'Notify',

  mixins: [mixins],

  data() {
    return {
      loadingIcon,
      notifyList: [],
      loading: true
    }
  },

  methods:{
    init() {
      this.initNotifyList();
      this.readNotify();
    },

    async initNotifyList() {
      const appid = cookie.get('App-Id') || this.debugAppId;
      const token = cookie.get('token') || this.debugToken;
      const notifyDataListRes = await getNotifyList({
        appid,
        token
      });

      if (notifyDataListRes.code === 0) {
        this.notifyList = this.makeNotifyRenderList(notifyDataListRes.data.list);
      }
      else {
        this.notifyList = [];
      }

      this.loading = false;
    },

    readNotify() {
      const appid = cookie.get('App-Id') || this.debugAppId;
      const token = cookie.get('token') || this.debugToken;

      updateReadNotifyStatus({
        appid,
        token
      });
    },

    makeNotifyRenderList(notifySrcData) {
      return notifySrcData.map((info, index) => {
        const { notify_id, title, content, created_at } = info;

        return {
          notify_id,
          title,
          content,
          expand: true,
          created_at: dayjs(created_at).locale('zh-cn').format('YYYY/MM/DD HH:mm')
        };
      });
    },

    expandToggle(item) {
      item.expand = !item.expand;
    },
  },

  mounted() {
    this.init();
  },
}
